import styles from './GeneralErrorHandler.module.scss'
import { Component, PropsWithChildren } from 'react'

const GeneralErrorHandler = class GeneralErrorHandler extends Component<PropsWithChildren> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <h1 className={styles['general-error']}>Oops, something went wrong!</h1>
    }

    return this.props.children
  }
}

export default GeneralErrorHandler
